import { gql } from '@apollo/client';

export default gql`
  mutation createOperationFinance($_id: String) {
    createOperationFinance(_id: $_id) {
      ok
      message
      data
      error
    }
  }
`;
